import React from 'react';
import {useTranslation} from 'react-i18next';
import {useUserContext} from 'authentication/UserContext';
import {ConfirmAggregateDialog} from 'components/Dialogs/ConfirmAggregateDialog/ConfirmAggregateDialog';
import {useSyncKeywordSuccessorsMutation} from '../hooks/keywords.generated';

export const SyncKeywordSuccessorsButton: React.FC = () => {
	const {t} = useTranslation('features/adminsection', {
		keyPrefix: 'AdminKeywordsPage',
	});

	const [syncKeywordSuccessors] = useSyncKeywordSuccessorsMutation();

	const {isAdmin} = useUserContext();

	const handleConfirm = () => {
		syncKeywordSuccessors();
	};

	return (
		<ConfirmAggregateDialog
			buttonKey='syncKeywordSuccessors'
			buttonText={t('SyncKeywordSuccessors')}
			buttonHidden={!isAdmin}
			handleConfirm={handleConfirm}
			dialogTitle={t('SyncKeywordSuccessors')}
			dialogText={t('SyncKeywordSuccessorsText')}
		/>
	);
};
